import { API_BASE } from "../account/api";

/**
 * Visits (DSPRT-400): one small POST for each page shown, so the admin
 * Visitors page can count them. No cookie and nothing stored on the device;
 * the server turns the request into a visitor for the day without keeping the
 * address (see the backend's V46).
 *
 * The app changes pages with pushState, and corrects an address with
 * replaceState a moment after load, so this waits for the address to settle
 * and sends only when the path has changed: a filter or a query string on the
 * same page is not another page view.
 */
const SETTLE_MS = 400;

let last: string | null = null;
let first = true;
let timer: number | undefined;

function send(): void {
  const path = window.location.pathname;
  if (path === last) return;
  last = path;
  const body = JSON.stringify({
    path,
    // Where the visit came from matters once, on its first page.
    ref: first ? document.referrer || null : null,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone ?? null,
    lang: navigator.language ?? null,
    w: window.innerWidth,
    app: window.matchMedia?.("(display-mode: standalone)").matches || (navigator as { standalone?: boolean }).standalone === true,
  });
  first = false;
  void fetch(`${API_BASE}/visit`, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

function soon(): void {
  window.clearTimeout(timer);
  timer = window.setTimeout(send, SETTLE_MS);
}

export function installVisitCount(): void {
  // A prerendered page or one opened in a background tab counts when it is first looked at.
  if (document.visibilityState === "visible") soon();
  else document.addEventListener("visibilitychange", function once() {
    if (document.visibilityState !== "visible") return;
    document.removeEventListener("visibilitychange", once);
    soon();
  });
  for (const name of ["pushState", "replaceState"] as const) {
    const original = history[name];
    history[name] = function (this: History, ...args: Parameters<History["pushState"]>) {
      original.apply(this, args);
      if (last !== null) soon();
    };
  }
  window.addEventListener("popstate", () => { if (last !== null) soon(); });
}
